import {css, cva} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    id: string;
    firstName: string | null;
    variant: "header" | "question";
    className?: string;
}

export const UnlockChoiceModalTitle = (props: IProps) => {
    const {id, firstName, variant, className} = props;

    const firstLine = firstName ? `${firstName}, wybierz jedną z opcji` : "Wybierz jedną z opcji";

    return (
        <Text as="h2" id={id} variant={variant === "header" ? "headline_4" : "body_copy_1"} color="var(--colors-secondary)" className={className}>
            <span className={firstLineStyle({variant})}>{firstLine}</span> <span className={secondLineStyle}>w zależności od Twojego etapu poszukiwań</span>
        </Text>
    );
};

const firstLineStyle = cva({
    base: {
        display: "block"
    },
    variants: {
        variant: {
            header: {
                fontWeight: 700
            },
            question: {}
        }
    }
});

const secondLineStyle = css({
    display: "block"
});
import {css, cva} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    id: string;
    firstName: string | null;
    variant: "header" | "question";
    className?: string;
}

export const UnlockChoiceModalTitle = (props: IProps) => {
    const {id, firstName, variant, className} = props;

    const firstLine = firstName ? `${firstName}, wybierz jedną z opcji` : "Wybierz jedną z opcji";

    return (
        <Text as="h2" id={id} variant={variant === "header" ? "headline_4" : "body_copy_1"} color="var(--colors-secondary)" className={className}>
            <span className={firstLineStyle({variant})}>{firstLine}</span> <span className={secondLineStyle}>w zależności od Twojego etapu poszukiwań</span>
        </Text>
    );
};

const firstLineStyle = cva({
    base: {
        display: "block"
    },
    variants: {
        variant: {
            header: {
                fontWeight: 700
            },
            question: {}
        }
    }
});

const secondLineStyle = css({
    display: "block"
});
